import IndexRedirect from './IndexRedirect';
import PrivateRoute from './PrivateRoute';

export {
  IndexRedirect,
  PrivateRoute
};



// WEBPACK FOOTER //
// ./src/common/routing/index.js